import { Select, Box, Text } from "@chakra-ui/react";

import NextIcon from "@/assets/NextIcon";
import PrevIcon from "@/assets/PrevIcon";
import { DEFAULT_OPTION_PAGE_SIZE } from "@/common/constants";
import { PaginationProps } from "./types";

const Pagination: React.FC<PaginationProps> = ({
    currentPageSize,
    currentPageNumber,
    totalPageNumber,
    handleChangePageSize,
    handleChangePageNumber,
    hasNextPage,
}) => {
    if (totalPageNumber === 0) {
        return (
            <></>
        )
    }

    return (
        <Box display="flex" gap={2} justifyContent="flex-end" fontSize="12px" margin="20px" style={{float:"left"}}>
            <Text pt={3}>Rows per page:</Text>
            <Select
                width="65px"
                fontSize="12px"
                cursor="pointer"
                value={currentPageSize}
                onChange={(e) => handleChangePageSize(Number(e.target.value))}
            >
                {DEFAULT_OPTION_PAGE_SIZE.map((size) => (
                    <option key={size} value={size}>
                        {size}
                    </option>
                ))}
            </Select>
            <Text pt={3}>
                {currentPageNumber} of {totalPageNumber}
            </Text>
            {currentPageNumber > 1 && (
                <PrevIcon style={{ marginTop: 8, cursor: 'pointer' }} onClick={() => handleChangePageNumber(currentPageNumber - 1)} />
            )}
            {hasNextPage && (
                <NextIcon style={{ marginTop: 8, cursor: 'pointer' }} onClick={() => handleChangePageNumber(currentPageNumber + 1)} />
            )}
        </Box>
    );
};

export default Pagination;
